import React, { useEffect } from "react";
import { TeamChatsContextImport } from "../../../../provider/chats/chats/team_chats/TeamChatsContextProvider";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import NoData from "../../../../widget/common/ui/NoData";
import { ConversationMessagesList } from "../../widget/chat_conversation/ConversationMessages";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import { socket } from "../../../../service/socket/SocketService";

const TeamChatConversations = () => {
  const { chatSelected, userId, socketStatus } = ChatsContextImport();

  const {
    conversationMessages,
    participantDetail,
    getSelectedChatSession,
    disconnectCallBacks,
    resetMessages,
    conversationCallBack,

    handlePressStart,
    handleClickMessage,
    handlePressEnd,
    selectedMesasgeIds,
    longPressStatus,
  } = TeamChatsContextImport();

  useEffect(() => {
    if (socketStatus) {
      getSelectedChatSession();
    }
    // eslint-disable-next-line
  }, [socketStatus]);

  useEffect(() => {
    resetMessages();

    socket.onAny(conversationCallBack);

    return () => {
      disconnectCallBacks();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {chatSelected != null && (
        <>
          {conversationMessages == null ? (
            <Center>{Loader.normal()}</Center>
          ) : Object.keys(conversationMessages).length === 0 ? (
            <NoData />
          ) : (
            <ConversationMessagesList
              flag={chatSelected?.flag!}
              userId={userId}
              messages={conversationMessages}
              participantDetail={participantDetail}
              handleClickMessage={handleClickMessage}
              handlePressStart={handlePressStart}
              handlePressEnd={handlePressEnd}
              selectedMesasgeIds={selectedMesasgeIds}
              longPressStatus={longPressStatus}
            />
          )}
        </>
      )}
    </>
  );
};

export default TeamChatConversations;
